export function timeAgo(iso: string): string {
  const seconds = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000))
  if (seconds < 60) return 'just now'
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes} min ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours} h ago`
  const days = Math.round(hours / 24)
  if (days < 30) return `${days} ${days === 1 ? 'day' : 'days'} ago`
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('')
}

/** Support hours: Monday to Friday, 08:00 to 18:00 Kigali time (UTC+2). */
export function isSupportOnline(date = new Date()): boolean {
  const kigali = new Date(date.getTime() + 2 * 3600 * 1000)
  const day = kigali.getUTCDay()
  const hour = kigali.getUTCHours()
  return day >= 1 && day <= 5 && hour >= 8 && hour < 18
}

export function downloadCsv(filename: string, rows: (string | number)[][]): void {
  const csv = rows.map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(',')).join('\n')
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }))
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

/** Parses "name, email" lines or a CSV with first_name,last_name,email or name,email headers. */
export function parsePeople(text: string): { name: string; email: string }[] {
  const lines = text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean)
  if (!lines.length) return []
  const header = lines[0].toLowerCase()
  const hasHeader = header.includes('email')
  const cols = hasHeader ? header.split(',').map((c) => c.trim()) : []
  const rows = hasHeader ? lines.slice(1) : lines
  return rows
    .map((line) => {
      const cells = line.split(/[,;\t]/).map((c) => c.trim().replace(/^"|"$/g, ''))
      if (hasHeader) {
        const get = (key: string) => cells[cols.indexOf(key)] ?? ''
        const name = get('name') || [get('first_name'), get('last_name')].filter(Boolean).join(' ')
        return { name, email: get('email') }
      }
      const email = cells.find((c) => c.includes('@')) ?? ''
      const name = cells.filter((c) => c !== email).join(' ')
      return { name, email }
    })
    .filter((p) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(p.email))
}
